import React, { useState, useEffect } from "react"
import { Box, Tooltip, InputLabel, MenuItem, FormControl, Select, TextField, useTheme } from "@material-ui/core"
import { KeyboardArrowDown, Clear as ClearIcon } from "@material-ui/icons"
import { makeStyles } from "@material-ui/core"
import { useSelector } from "react-redux"
import { VIEWED_FILTER_KIND } from "../../../utils"

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 121,
		minWidth: 121,
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiSvgIcon-fontSizeSmall": {
			fontSize: "0.7rem",
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
}))

const View = ({ handleViewedTypeChange, viewType = "", setViewType = () => {}, disableFilters }) => {
	const classes = useStyles()
	const theme = useTheme()

	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)

	const MenuProps = {
		PaperProps: {
			style: {
				// width: 216,
				minWidth: 140,
				maxWidth: 140,
				textTransform: "capitalize",
			},
		},
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left",
		},
		getContentAnchorEl: null,
	}

	const handleChange = (event) => {
		setViewType(event.target.value)
		handleViewedTypeChange(event.target.value)
	}

	const handleClear = () => {
		setViewType("")
		handleViewedTypeChange(VIEWED_FILTER_KIND.default)
	}

	const selectDom = (
		// <Select
		// 	variant="outlined"
		// 	labelId="view-filter-select-label" //
		// 	id="view-filter-select"
		// 	value={viewType}
		// 	//label="View"
		// 	onChange={handleChange}
		// 	MenuProps={MenuProps} //
		// 	IconComponent={KeyboardArrowDown} //
		// >
		<TextField
			//style={{ width: "100%" }}
			//style={{ color: "#2C3533", fontWeight: "700" }}
			variant="outlined"
			value={viewType}
			onChange={handleChange}
			select
			label="View"
			id="view-filter-select-label"
			SelectProps={{
				labelId: "view-filter-select-label",
				MenuProps: MenuProps,
				IconComponent: KeyboardArrowDown,
				endAdornment:
					viewType === VIEWED_FILTER_KIND.viewed || viewType === VIEWED_FILTER_KIND.not_viewed ? (
						<div
							onClick={handleClear}
							style={{
								right: 25,
								position: "absolute",
								cursor: "pointer",
								pointerEvents: isReviewFormOpen ? "none" : "auto",
							}}
						>
							<ClearIcon fontSize="small" />
						</div>
					) : null,
			}}
			InputLabelProps={{ style: { fontWeight: 400 } }}
			disabled={disableFilters}
			size="small"
			className={classes.select}
			fullWidth
		>
			<MenuItem value={VIEWED_FILTER_KIND.viewed} style={{ fontWeight: 400 }}>
				Viewed
			</MenuItem>
			<MenuItem value={VIEWED_FILTER_KIND.not_viewed} style={{ fontWeight: 400 }}>
				Not Viewed
			</MenuItem>
		</TextField>
		// </Select>
	)

	return (
		<Box className={classes.boxWrapper} m={1}>
			<FormControl fullWidth size="small">
				{/* <InputLabel id="view-filter-select-label">View</InputLabel> */}
				{viewType || viewType === "0" ? (
					<Tooltip
						placement="top"
						arrow
						//{...(viewType || viewType === "0" ? { title: viewType === "0" ? "Viewed" : "Not Viewed" } : {})}
						title={viewType === VIEWED_FILTER_KIND.viewed ? "Viewed" : "Not Viewed"}
					>
						{selectDom}
					</Tooltip>
				) : (
					selectDom
				)}
			</FormControl>
		</Box>
	)
}

export default View
